<form [formGroup]="filterForm" class="user-management_filters">
  <!-- Search by Standard Name -->
  <div class="filter-field">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        id="standardName"
        type="text"
        pInputText
        formControlName="search"
        [placeholder]="
          inputPlaceholder() ? inputPlaceholder() : 'Search by Name or Email'
        "
      />
    </p-iconField>
  </div>
  <!-- Filters group -->
  <div class="filter-controls">
    <!-- User Role -->
    @if(categories().length === 0) {
    <stc-apps-editable-dropdown
      [placeholder]="'Role'"
      formControlName="role"
      [dropdownOptions]="ROLE_OPTIONS"
    ></stc-apps-editable-dropdown>

    }

    <!-- Status -->
    <stc-apps-editable-dropdown
      [placeholder]="'Status'"
      formControlName="status"
      [dropdownOptions]="categories().length > 0 ? categories() : statusOptions"
    ></stc-apps-editable-dropdown>
  </div>
</form>
